(function () {
  'use strict';

  /* CG Spine Video — the ambient video plays only while on screen.
     The <video> carries no autoplay attribute: playback starts here when
     the section is at least 25% visible and pauses when it leaves, so
     nothing decodes offscreen. prefers-reduced-motion visitors keep the
     poster still. */

  function initVideo(video) {
    if (video.dataset.cgSvInit === '1') return;
    video.dataset.cgSvInit = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Chrome's autoplay policy checks the muted IDL property, not the
    // HTML attribute — set it explicitly before any play() attempt.
    video.muted = true;

    function tryPlay() {
      const played = video.play();
      if (played && typeof played.catch === 'function') {
        // iOS low-power mode rejects play(); the poster stays visible.
        played.catch(function () {});
      }
    }

    if (typeof IntersectionObserver !== 'function') {
      tryPlay();
      return;
    }

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tryPlay();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    io.observe(video);
  }

  function init(scope) {
    const ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-cg-spine-video]').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
